import { Box, Button, Paper, Stack, Typography } from "@mui/material"

const CriticalError = (props) => {

	const handleHelpDesk = () => {
		const email 	= "suporte@stockscreener.com.br"; // Change to your support email
		const subject 	= encodeURIComponent("Erro crítico no sistema");
		const body 		= encodeURIComponent("Olá, estou enfrentando um erro crítico no sistema. Detalhes do erro: \n\n"+ props.error + "\n\nInformações adicionais: " + JSON.stringify(props.errorInfo, null, 2));
		
		window.location.href = `mailto:${email}?subject=${subject}&body=${body}`;
	}

	const handleReload = () => {
		window.location.reload()
	}
	
	return (
		<Box sx={{display: 'flex', width: '100%', height: props.height ? props.height : '88vh', alignItems: 'center', justifyContent: 'center'}}>
			<Paper elevation={4} sx={{paddingY: 6, paddingX: 4, borderRadius: 4}}>
				<Stack direction={'column'} alignItems={'center'} width={'100%'} spacing={1}>
					<img src={`${process.env.PUBLIC_URL}/images/system/criticalError.png`} alt='imagem de erro' width={300} height={300}/>
					<Typography variant="h1" paddingLeft={1} fontWeight={800}>Ocorreu um erro crítico!</Typography>
					<Typography paddingLeft={1}>Um erro inesperado ocasionou a parada do sistema. Por favor, escolha as opções abaixo</Typography>
					<Stack direction={'row'} spacing={1} justifyContent={'center'} paddingTop={4}>
						<Button variant="contained" onClick={handleHelpDesk}>Falar com o suporte</Button>
						<Button variant="contained" onClick={handleReload}>Recarregar a página</Button>
					</Stack>
					
				</Stack>
			</Paper>
		</Box>
	)
}

export default CriticalError